import HttpService from '@/services/http/http.service';

export default class AdminCourseService {
	constructor() {
		this.http = new HttpService();
	}

	createCourse(course) {
		return this.http.post('admin/course', {
			name: course.name,
			description: course.description,
			code: course.code,
		});
	}

	updateCourse(course) {
		return this.http.put(`admin/course/${course.id}`, {
			name: course.name,
			description: course.description,
			code: course.code,
		});
	}

	getCourses() {
		return this.http.get('admin/course');
	}

	get(courseId) {
		return this.http.get(`admin/course/${courseId}`);
	}
}
